import { render, staticRenderFns } from "./local-dana.vue?vue&type=template&id=18f4713c"
import script from "./local-dana.vue?vue&type=script&lang=js"
export * from "./local-dana.vue?vue&type=script&lang=js"
import style0 from "./local-dana.vue?vue&type=style&index=0&id=18f4713c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports